import {Price} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//price.types';
import {
  BrandTracker,
  ProductTracker,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//tracker.types';
import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {PriceV2} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/price_v2.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {
  TrackingElementContext,
  TrackingRecoElement,
  TrackingSectionContext,
  TrackingStreamSectionContext,
  additionalDataForAddToWishlist,
  trackWishlistAction,
} from '@aboutyou/legacy-tracking-sdk';
import {
  getSections,
  trackingProductGetter,
} from '../utils/trackingProductGetter';
import {useTracking} from '../utils/utils';

export const useTrackWishlist = ({
  product,
  price,
  brand,
  streamPosition,
  trackingData,
  badges,
}: {
  product: Product | ProductTracker;
  price?: Price | PriceV2;
  brand: Brand | BrandTracker;
  streamPosition: number;
  trackingData?: {
    sectionIndex?: number;
    sortingChannel?: string;
    pageType?: string;
    recoType?: string;
    elements?: TrackingRecoElement[];
    blockTypeAndId?: string;
    creativeName?: string;
    promotionId?: string;
  };
  badges: string[];
}) => {
  const {TrackingClient, pageContextCallback} = useTracking();

  return (action: 'add-to-wishlist' | 'removed-from-wishlist') => {
    const sections = getSections({
      sortChannel: trackingData?.sortingChannel,
      sectionIndex: trackingData?.sectionIndex,
      recoType: trackingData?.recoType,
      elements: trackingData?.elements,
      pageType: trackingData?.pageType ?? pageContextCallback().type,
      blockTypeAndId: trackingData?.blockTypeAndId,
      streamPosition,
    });
    const trackingWishlistItem = getTrackingWishlistItem({
      tile: product,
      price,
      brand,
      streamPosition,
      sections,
      creativeName: trackingData?.creativeName,
      promotionId: trackingData?.promotionId,
      badges,
    });
    TrackingClient.track(
      trackWishlistAction({
        type: action,
        ...sections,
        wishlistItem: trackingWishlistItem,
      }),
    );
  };
};

export const getTrackingWishlistItem = ({
  tile,
  price,
  brand,
  streamPosition,
  sections,
  creativeName,
  promotionId,
  badges,
}: {
  tile: Product | ProductTracker;
  price?: Price | PriceV2;
  brand: Brand | BrandTracker;
  streamPosition: number;
  sections: {
    element: TrackingElementContext;
    section: TrackingSectionContext;
  };
  creativeName?: string;
  promotionId?: string;
  badges: string[];
}) => {
  const {product} = trackingProductGetter({
    product: tile,
    price,
    brand,
    streamPosition,
    sortChannel: (sections.section as TrackingStreamSectionContext).sortChannel,
    creativeName,
    promotionId,
    badges,
  });

  // prevent triggering getter for tracking client on server
  const additionalWishlistData =
    process.browser && window.clientState
      ? additionalDataForAddToWishlist(window.clientState)({
          ...sections,
        })
      : undefined;

  return {
    key: '',
    product,
    variant: undefined,
    additionalWishlistData,
  };
};
